// framework/common/schemas/collections/subscriptions.js
import { z } from "zod";

// This schema defines the subscription/tenant entity itself.
const SubscriptionSchema = z.object({
    _id: z.string().optional(),
    // A special, well-known name for the default single subscription
    name: z.string().describe("Identifier for the subscription, e.g., '__default_single_tenant__' or a company name."),
    serviceCode: z.string().describe("The user-facing code for logging in (e.g., 'ACME-1234')."),
    // Optional details about the subscription
    plan: z.string().optional().default("default"),
    status: z.enum(["active", "suspended", "cancelled"]).default("active"),
    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
});

export default SubscriptionSchema;